import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';

import { observationScaleToggleButtonSx } from './observationScaleUi';

const fieldValue = (payload, groupKey, fieldKey) => String(payload?.[groupKey]?.[fieldKey] || '');

function ObservationScaleFieldRow({ field, groupKey, payload, onChange }) {
  const value = fieldValue(payload, groupKey, field.key);

  const handleChange = (_, nextValue) => {
    onChange((prev) => ({
      ...prev,
      [groupKey]: {
        ...(prev?.[groupKey] || {}),
        [field.key]: nextValue || '',
      },
    }));
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '180px 1fr' },
        gap: 1.25,
        alignItems: 'center',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {field.label}
      </Typography>
      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        value={value}
        onChange={handleChange}
        sx={{
          '& .MuiToggleButton-root': {
            textTransform: 'none',
            fontWeight: 600,
          },
        }}
      >
        <ToggleButton value="iyi" sx={observationScaleToggleButtonSx('iyi')}>İyi</ToggleButton>
        <ToggleButton value="orta" sx={observationScaleToggleButtonSx('orta')}>Orta</ToggleButton>
        <ToggleButton value="gelistirilmeli" sx={observationScaleToggleButtonSx('gelistirilmeli')}>Geliştirilmeli</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default function ObservationStructuredForm({ schema, payload, onChange, noteInputRef }) {
  const academicFields = schema?.academic_fields || [];
  const generalFields = schema?.general_fields || [];

  return (
    <Stack spacing={2.5}>
      <TextField
        label="Öğretmen gözlemi"
        required
        multiline
        minRows={4}
        fullWidth
        inputRef={noteInputRef}
        value={payload?.note || ''}
        onChange={(event) =>
          onChange((prev) => ({
            ...prev,
            note: event.target.value,
          }))
        }
        placeholder="Öğrenciyle ilgili gözlemlerinizi ve velilere iletmek istediğiniz notları yazın..."
        helperText="Gözlem kaydı için öğretmen notu gereklidir. Aşağıdaki durum alanlarını isterseniz ekleyebilirsiniz."
      />

      {academicFields.length > 0 ? (
        <Stack spacing={1.5}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            Ders durumları (opsiyonel)
          </Typography>
          {academicFields.map((field) => (
            <ObservationScaleFieldRow
              key={field.key}
              field={field}
              groupKey="academic"
              payload={payload}
              onChange={onChange}
            />
          ))}
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Bu öğrenci için size açık akademik gözlem alanı bulunmuyor.
        </Typography>
      )}

      <Stack spacing={1.5}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Genel durumlar (opsiyonel)
        </Typography>
        {generalFields.map((field) => (
          <ObservationScaleFieldRow
            key={field.key}
            field={field}
            groupKey="general"
            payload={payload}
            onChange={onChange}
          />
        ))}
      </Stack>

    </Stack>
  );
}
